import { ElMessage } from "element-plus";

const commonFn = {
  success(message) {
    ElMessage({
      message,
      type: 'success',
      offset: 120,
    });
  },
  warning(message) {
    ElMessage({
      message,
      type: 'warning',
      offset: 120,
    });
  },
  error(message) {
    ElMessage({
      message,
      type: 'error',
      offset: 120,
    });
  },
};

commonFn.suffix = {
  pic: ['jpg', 'jpeg','png', 'gif'],  // 图片
  ppt: ['ppt', 'pptx','potx', 'pot', 'pdf', 'doc', 'docx', 'xls', 'xlsx'],  // ppt
  wordToHTML: ['docx'],
},

// 获取  .jpg,.jpeg,.png,.gif  这种格式，用于el-upload限制上传类型
commonFn.getAccept = (type, onlyLowerCase = false) => {
  let arr = [];
  if (type && typeof type == 'object') {
    type.forEach(v => {
      arr = arr.concat(commonFn.suffix[v]);
    });
  } else {
    arr = type ? commonFn.suffix[type] : commonFn.suffixAll();
  }
  let str = '';
  if (onlyLowerCase) {
    str = '.' + arr.join(',.');
  } else {
    str = '.' + arr.join(',.') + ',.' +  arr.join(',.').toUpperCase();
  }
  return str;
},

// 文件后缀是否匹配
// suffix-后缀名 或 file
// type-commonFn.suffix的类型名如pic，多个传数组
commonFn.matchSuffix = (suffix, type) => {
  if (!suffix || !type) {
    return false;
  }
  let acceptList = [];
  if (typeof type == 'object') {
    type.forEach(v => {
      acceptList = acceptList.concat(commonFn.suffix[v] || []);
    });
  } else {
    acceptList = commonFn.suffix[type] || [];
  }
  let _suffix = '';
  if (typeof suffix == 'object') {
    let arr = suffix.name.split('.');
    suffix = arr[arr.length - 1];
  }
  _suffix = suffix.toLowerCase()
  return acceptList.includes(_suffix);
},


/**
 * 将file文件转化为base64
 * @param file
 */
 commonFn.fileToBase64 = function (file) {
  return new Promise((resolve, reject) => {
    if (commonFn.matchSuffix(file, 'pic')) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => resolve('')
    } else {
      resolve('');
    }
  });
}

// 通过链接||图片文件获取图片宽高
commonFn.getImgWandH = function (url) {
  return new Promise(resolve => {
    if (!url) {
      resolve({})
    }
    var img = new Image();
    img.src = url;
    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height,
        proportion: (img.width / img.height).toFixed(2) * 1,
      })
    };
    img.onerror = () => {
      resolve({})
    }
  });
},

// 路由跳转
commonFn.toPage = function (path, query = {}, messageType = 'error') {
  if (path == -1) {
    if (typeof query == 'string') {
      ElMessage[messageType](query);
      setTimeout(() => {
        window.history.length == 1 ? this.$router.push('/') : this.$router.back();
      }, 1000)
    } else {
      window.history.length == 1 ? this.$router.push('/') : this.$router.back();
    }
    return;
  }
  if (!path) { return; }
  if (/^http/.test(path)) {
    window.open(path)
  } else {
    path = decodeURIComponent(path)
    let _query = path.split('?')[1];
    path = path.split('?')[0];
    if (_query) {
      _query.split('&').forEach(v => {
        query[v.split('=')[0]] = v.split('=')[1];
      })
    }
    this.$router.push({
      path,
      query
    });
  }
}
commonFn.replace = function (path, query = {}, messageType = 'error') {
  if (path == -1) {
    commonFn.toPage(path, query, messageType)
    return;
  }
  if (!path) { return; }
  if (/^http/.test(path)) {
    window.location.replace(path)
  } else {
    path = decodeURIComponent(path)
    let _query = path.split('?')[1];
    path = path.split('?')[0];
    if (_query) {
      _query.split('&').forEach(v => {
        query[v.split('=')[0]] = v.split('=')[1];
      })
    }
    this.$router.replace({
      path,
      query
    });
  }
}

// 时间格式
commonFn.time = function (val, format) {
  if (!val) {
    return ''
  }
  format = format || 'YYYY-MM-DD';
  if (/\/Date/.test(val)) {
    val = parseInt(val.replace("/Date(", "").replace(")/", ""))
  }
  // 转成2020/01/01格式因为ios不支持2020-01-01格式
  try {val = val.replace(/-/g, '/');} catch(err) {}
  let time = new Date(val);
  if (time == 'Invalid Date') {
    return val;
  }
  let obj = {
    'YYYY': time.getFullYear(),
    'MM': time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1,
    'M': time.getMonth() + 1,
    'DD': time.getDate() < 10 ? '0' + time.getDate() : time.getDate(),
    'D': time.getDate(),
    'hh': time.getHours() < 10 ? '0' + time.getHours() : time.getHours(),
    'h': time.getHours(),
    'mm': time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes(),
    'm': time.getMinutes(),
    'ss': time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds(),
    's': time.getSeconds()
  }
  for (let i in obj) {
    format = format.replace(i, obj[i]);
  }
  return format;
}

// 生成随机字符串
commonFn.randomString = function(e = 8) { 
  var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
    a = t.length,
    n = "";
  for (let i = 0; i < e; i++) {
    n += t.charAt(Math.floor(Math.random() * a));
  }
  return n;
}

// LocalStorage
commonFn.getLocalStorage = function (name) {
	var value = undefined;
  try {
    var obj = JSON.parse(localStorage.getItem(name));
    if (new Date().getTime() > obj.expiresTime) {
      localStorage.removeItem(name);
      return undefined;
    } else {
      value = obj.value;
    }
  } catch (error) {}
	return value;
}
commonFn.setLocalStorage = function (name, value = '', _time = 'd36500') {
  // d30-30天过期，h30-30小时过期，s30-30秒过期
	var str1 = _time.substring(1, _time.length) * 1;
	var str2 = _time.substring(0, 1);
	if (str2 == "s") {
		_time = str1 * 1000;
	} else if (str2 == "h") {
		_time = str1 * 60 * 60 * 1000;
	} else if (str2 == "d") {
		_time = str1 * 24 * 60 * 60 * 1000;
	}
  var _value = {
		value: value,
		expiresTime: new Date().getTime() + _time
	}
	localStorage.setItem(name, JSON.stringify(_value));
}
commonFn.removeLocalStorage = function (name) {
  localStorage.removeItem(name);
}

// 获取cookie
commonFn.getCookie = function (name) {
  const cookies = document.cookie.split("; ");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].split("=");
    if (cookie[0] === name) {
      return cookie[1];
    }
  }
  return "";
}


// 方特网新闻类型
commonFn.F_newsTypeList = [
  {id: '4', name: '华强方特热讯' },
  {id: '2', name: '媒体聚焦' },
  // {id: '23', name: '华强方特热讯(手机版)' },
  // {id: '24', name: '媒体聚焦(手机版)' },
  {id: '14', name: '培养与发展' },
  {id: '15', name: '华强生活' },
  // {id: '16', name: '熊出没品牌动态' },
  // {id: '18', name: '生肖传奇动态' },
  // {id: '19', name: '小虫虫有大智慧动态' },
  // {id: '17', name: '小鸡不好惹动态' },
  // {id: '5', name: '方特主题公园' },
  // {id: '6', name: '校园招聘' },
  // {id: '8', name: '方特游戏频道' },
  // {id: '9', name: '手机新闻' },
  // {id: '7', name: '方特玩具城' },
  // {id: '25', name: '专链新闻' },
]
commonFn.F_newsTypeListEn = [
  {id: '10', name: 'News' },
  {id: '11', name: 'Media Focus' },
  {id: '12', name: 'FunToys' },
  // {id: '13', name: 'PhoneNews' },
]
// 方特网调研类型
commonFn.F_bidTypeList = [
  {id: '0', name: '工程类' },
  {id: '2', name: '采购类' },
  {id: '3', name: '管理服务类' },
]
// 方特轮播图类型
commonFn.F_bannerList = [
  { id: 1, name: '中文', bannerSize: '1920 × 658px', },
  // { id: 2, name: '手机', bannerSize: '720 × 360px', },
  { id: 3, name: '英文', bannerSize: '1920 × 658px', },
  // { id: 4, name: '手机_英文', bannerSize: '720 × 360px', },
]
// 用户类型
commonFn.userTypeList = [
  {id: '1', name: '管理员' },
  {id: '2', name: '园区用户' },
  {id: '3', name: '华强方特官网用户' },
]
// 额外的公园
commonFn.extparkList = [
  {park_id: -1, park_name: '全部' },
  {park_id: -2, park_name: '新闻_中文' },
  {park_id: -3, park_name: '新闻_英文' },
  {park_id: -4, park_name: '调研' },
]

// 公园类型
commonFn.parkTypeList = [
  {id: 1, name: '欢乐世界', themeColor: ['#c30', '#D45625', '#3366CC'], 
    defaultList: [
      ['园区营业时间', '项目开放时间'],
      ['门票', '年卡', '套票'],
      ['停车收费', '寄存收费', '游览车收费'],
    ],
    bannerSize: '旧版 1200 × 532px，新版 1920 × 680px',
  },
  {id: 2, name: '梦幻王国', themeColor: ['#c30', '#D45625'], themeBgcolor: ['#ffebdb'],
    defaultList: [
      ['园区开放时间', '项目开放时间'],
      ['门票', '年卡', '套票'],
      ['停车收费', '寄存收费', '贵宾车收费'],
    ],
    bannerSize: '旧版 1920 × 658px，新版 1920 × 700px',
  },
  {id: 3, name: '东方神画', themeColor: ['#c30','#D45625', '#078C04'], themeBgcolor: ['#ffebdb'],
    defaultList: [
      ['营业时间', '平日时间表'],
      ['门票', '年卡', '套票'],
      ['停车收费', '寄存收费', '贵宾车收费'],
    ],
    bannerSize: '690 × 280 px',
  },
  {id: 4, name: '水上乐园', themeColor: ['#1f73ca', '#fb9f3c'], themeBgcolor: ['#56C7FD'],
    defaultList: [
      ['园区开放时间', '项目开放时间'],
      ['门票价格', '年票价格', '套票价格'],
      ['停车收费', '寄存收费', '贵宾车收费'],
    ],
    bannerSize: '1920 × 693 px',
  },
  {id: 5, name: '东盟神画', themeColor: ['#ac7f6e', '#c96118', '#fe5c3c'],
    defaultList: [
      ['园区营业时间', '项目开放时间'],
      ['门票', '年卡', '套票'],
      ['停车收费', '寄存收费', '贵宾车收费'],
    ],
    bannerSize: '',
  },
  {id: 6, name: '丝路神画', themeColor: ['#6E3D91', '#934ED1', '#2BC674'],
    defaultList: [
      ['园区营业时间', '项目营业时间'],
      ['日票', '年票', '套票'],
      ['停车收费', '寄存收费', '贵宾车收费'],
    ],
    bannerSize: '1920 × 750px',
  },
  {id: 7, name: '国色春秋', themeColor: ['#E5753C', '#FE5C3C', '#2BC674'],
    defaultList: [
      ['园区营业时间', '项目营业时间'],
      ['日票', '年卡', '套票'],
      ['停车收费', '寄存收费', '贵宾车收费'],
    ],
    bannerSize: '1920 × 1035 px',
  },
  {id: 8, name: '东方欲晓', themeColor: ['#d6581a', '#f26d2c'],
    defaultList: [
      ['园区营业时间', '项目开放时间'],
      ['日票', '年卡', '套票'],
      ['停车收费', '寄存收费', '贵宾车收费'],
    ],
    bannerSize: '1920 × 736px',
  },
  {id: 9, name: '恐龙王国', themeColor: ['#E5753C', '#AF532F', '#14A18B'],
    defaultList: [
      ['园区营业时间', '项目开放时间'],
      ['门票', '年卡', '套票'],
      ['停车收费', '寄存收费', '贵宾车收费'],
    ],
    bannerSize: '553 × 315 px'
  },
  {id: 10, name: '狂野大陆', themeColor: ['#CB1D21', '#CB4F19', '#0EB13C'],
    defaultList: [
      ['园区营业时间', '项目开放时间'],
      ['日票', '年卡', '套票'],
      ['停车收费', '寄存收费', '贵宾车收费'],
    ],
    bannerSize: ''
  },
  {id: 11, name: '方特乐园', themeColor: ['#FD6143', '#CB4F19', '#4D8BFD'],
    defaultList: [
      ['园区营业时间', '项目开放时间'],
      ['日票', '年卡', '套票'],
      ['停车收费', '寄存收费', '贵宾车收费'],
    ],
    bannerSize: '1557 × 543 px',
  },
  {id: 12, name: '熊出没欢乐港湾',
    defaultList: [
      ['园区营业时间', '项目开放时间'],
      ['日票', '年卡', '套票'],
      ['停车收费', '寄存收费', '贵宾车收费'],
    ],
    authorNormal: 1, // 1表示使用公园全称
  },
  {id: 13, name: '熊出没乐园', themeColor: ['#E5753C', '#AF532F', '#14A18B'],
    defaultList: [
      ['园区营业时间', '项目开放时间'],
      ['门票', '年卡', '套票'],
      ['停车收费', '寄存收费', '贵宾车收费'],
    ],
    bannerSize: '1920 × 1076 px',
    authorNormal: 1
  },
  {id: 14, name: '水世界', themeColor: ['#4481f3', '#2f3baf', '#14a18b'],
    defaultList: [
      ['园区开放时间', '项目开放时间'],
      ['门票', '年卡', '套票'],
      ['停车收费', '寄存收费', '贵宾车收费'],
    ],
    bannerSize: '1920 × 1213 px'
  },
  {id: 15, name: '殷商神画', themeColor: ['#a53a05', '#b54928', '#fffcf0'],
    defaultList: [
      ['园区开放时间', '项目开放时间'],
      ['门票', '年卡', '套票'],
      ['停车收费', '寄存收费', '贵宾车收费'],
    ],
    bannerSize: '1920 × 670 px'
  },
  {id: 100, name: '其他', bannerSize: '1920 × 600px', authorNormal: 1},
]

commonFn.getParkByType = function(typeId) {
  let obj = commonFn.parkTypeList.filter(v => {
    return v.id == typeId;
  })[0] || {};
  return obj;
}

commonFn.getTableHead = function(key) {
  if (!key) {
    return {};
  }
  let textOpt = {};
  commonFn[key].forEach(v => {
    textOpt[v.id] = { replace: v.name };
  });
  return textOpt;
}

commonFn.getSearchList = function(key) {
  if (!key) {
    return [];
  }
  let options = [];
  commonFn[key].forEach(v => {
    options.push({
      label: v.name, id: v.id,
    });
  });
  return options;
}

commonFn.sanitigzeUrl= function(url) {
  const allowedProtocols= ['http:', 'https:'];
  try {
    const parsed = new URL(url, window.location.origin);
    return allowedProtocols.includes(parsed.protocol) ? parsed.href : '#';
  } catch {
    return '#';
  }
}

export default commonFn;